export const GRID_TILE_SIZE = 32
export const GRID_BORDER_WIDTH = 1

export interface GridSnapStyle {
  position: 'absolute'
  left: number
  top: number
  width: number
  height: number
}

export interface GridSnapHelpers {
  tileSize: number
  gridWidth: (cols: number) => number
  gridHeight: (rows: number) => number
  gridSnap: (
    col: number,
    row: number,
    colSpan: number,
    rowSpan: number,
  ) => GridSnapStyle
}

export function createGridSnap(tileSize: number): GridSnapHelpers {
  const gridWidth = (cols: number): number =>
    cols * tileSize + GRID_BORDER_WIDTH
  const gridHeight = (rows: number): number =>
    rows * tileSize + GRID_BORDER_WIDTH

  return {
    tileSize,
    gridWidth,
    gridHeight,
    gridSnap: (col, row, colSpan, rowSpan) => ({
      position: 'absolute',
      left: col * tileSize + GRID_BORDER_WIDTH,
      top: row * tileSize + GRID_BORDER_WIDTH,
      width: gridWidth(colSpan),
      height: gridHeight(rowSpan),
    }),
  }
}

export const {
  /** Pixel width for N columns. */
  gridWidth,
  /** Pixel height for N rows. */
  gridHeight,
  /** Returns absolute position style snapped to grid coordinates (0-indexed). */
  gridSnap,
} = createGridSnap(GRID_TILE_SIZE)
